import { Api } from "@/plugins/api";

export default class BaseModel {
    protected static readonly api = new Api();
}
